<template>
  <div>
    <aha-logo-loader
      v-if="!isWhiteLabel"
      :class="additionalClasses"
      :displayText="displayText"
    />
    <div class="white-label-loader" :class="additionalClasses" v-else>
      <aha-spinner size="lg" variant="tail" />
      <p class="mt-6" v-if="displayText">
        Just a moment please...
      </p>
    </div>
  </div>
</template>

<script>
import Utils from '@/util'

export default {
  name: 'InlineLoader',
  props: {
    displayText: {
      type: Boolean,
      default: false,
    },
    additionalClasses: {
      type: [String, Array],
      default: '',
    },
  },
  computed: {
    isWhiteLabel() {
      return Utils.checkWhiteLabelDomain()
    },
  },
}
</script>

<style lang="scss" scoped>
.white-label-loader {
  @apply flex content-center justify-center items-center;
}
</style>
